import { useMemo } from 'react';
import { useQuestionStats } from '../utils/quizStats';

function QuestionStats({ questionId }) {
  const { ultimosCincoIntentos, totalAciertos, totalFallos, porcentajeAcierto } =
    useQuestionStats(questionId);

  const circles = useMemo(() => {
    const recentAttempts = [...ultimosCincoIntentos];
    while (recentAttempts.length < 5) recentAttempts.push(null);
    return recentAttempts;
  }, [ultimosCincoIntentos]);

  return (
    <section className="question-stats" aria-label="Estadisticas de la pregunta">
      <div className="question-stats__recent">
        <span className="question-stats__label">Ultimos 5</span>
        <div className="question-stats__circles">
          {circles.map((attempt, index) => {
            const stateClass = !attempt ? 'empty' : attempt.correcto ? 'success' : 'error';
            return (
              <span
                key={`${questionId}-${index}-${attempt?.timestamp ?? 'empty'}`}
                className={`question-stats__circle ${stateClass}`}
                title={
                  !attempt
                    ? 'Sin datos'
                    : `${attempt.correcto ? 'Correcta' : 'Incorrecta'} · ${new Date(attempt.timestamp).toLocaleString()}`
                }
              />
            );
          })}
        </div>
      </div>
      <div className="question-stats__summary">
        <span className="question-stats__pill question-stats__pill--success">
          {totalAciertos} aciertos
        </span>
        <span className="question-stats__pill question-stats__pill--error">
          {totalFallos} fallos
        </span>
        <span className="question-stats__pill question-stats__pill--neutral">
          {porcentajeAcierto}%
        </span>
      </div>
    </section>
  );
}

export default QuestionStats;
